import { render, staticRenderFns } from "./QuestionInfos.vue?vue&type=template&id=66b797da"
import script from "./QuestionInfos.vue?vue&type=script&lang=js"
export * from "./QuestionInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports